(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["motion-freight-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('motion-freight-estimator')) {
    customElements.define('motion-freight-estimator', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-calculate]');
        this.result = this.querySelector('[data-result]');
        this.button.addEventListener('click', () => this.calculate());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && event.target.matches('[data-postcode]')) {
            event.preventDefault();
            this.calculate();
          }
        });
        this.addEventListener('input', () => this.reset());
        this.addEventListener('change', () => this.reset());
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.reset());
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.unsubscribe?.();
      }
      reset() {
        this.controller?.abort();
        this.result.replaceChildren();
        this.button.disabled = false;
      }
      async calculate() {
        if (this.button.disabled) return;
        const zip = this.querySelector('[data-postcode]').value.trim();
        const code = this.querySelector('[data-state]').value;
        const states = {ACT:'Australian Capital Territory',NSW:'New South Wales',NT:'Northern Territory',QLD:'Queensland',SA:'South Australia',TAS:'Tasmania',VIC:'Victoria',WA:'Western Australia'};
        if (!/^\d{4}$/.test(zip) || !states[code]) {
          this.result.textContent = this.dataset.invalid;
          return;
        }
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const signal = controller.signal;
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const params = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Australia','shipping_address[province]':states[code]});
        const request = async (path, method = 'GET') => {
          const response = await fetch(root + path, {method,signal,credentials:'same-origin',headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('rate-request');
          const text = await response.text();
          return text ? JSON.parse(text) : null;
        };
        this.button.disabled = true;
        this.result.textContent = this.dataset.loading;
        const timer = setTimeout(() => controller.abort(), 20000);
        try {
          const cart = await request('cart.js');
          if (!cart.item_count) {this.result.textContent = this.dataset.empty;return;}
          const fingerprint = JSON.stringify(cart.items.map(i => [i.key,i.quantity,i.final_line_price]));
          await request('cart/prepare_shipping_rates.json?' + params, 'POST');
          let data = null;
          for (let attempt = 0; attempt < 12; attempt++) {
            data = await request('cart/async_shipping_rates.json?' + params);
            if (data !== null) break;
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          if (!data || !Array.isArray(data.shipping_rates)) throw new Error('rate-timeout');
          const latest = await request('cart.js');
          if (fingerprint !== JSON.stringify(latest.items.map(i => [i.key,i.quantity,i.final_line_price]))) throw new Error('cart-changed');
          if (!this.isConnected || signal.aborted) return;
          this.result.replaceChildren();
          if (!data.shipping_rates.length) {this.result.textContent = this.dataset.none;return;}
          const list = document.createElement('ul');
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:cart.currency || this.dataset.currency || 'AUD'});
          data.shipping_rates.forEach(rate => {
            const price = Number(rate.price);
            if (!Number.isFinite(price)) throw new Error('invalid-rate');
            const item = document.createElement('li');
            item.textContent = rate.name + ' — ' + money.format(price);
            list.append(item);
          });
          this.result.append(list);
        } catch (error) {
          if (this.isConnected && this.controller === controller && this.button.disabled) this.result.textContent = this.dataset.error;
        } finally {
          clearTimeout(timer);
          if (this.controller === controller) this.button.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
